import { LitElement, html } from "lit-element";
import { close, fileDownload } from "../styles/icons.js";
import { SharedStyles } from "../styles/shared-styles.js";
import { store } from "../inspx-store.js";
import { downloadPdfReport } from "../actions/pdf-utils.js";

export class InspReportViewer extends LitElement {
	render() {
		return html`
				${SharedStyles}
        <style>
            :host {
                position: fixed;
                top: 0;
                left: 0;
                width: 100vw;
                height: 100vh;
                background-color: white;
                z-index: 9998;
            }
        
            .container {
                width: 100%;
                height: calc(100% - 60px);
                position: relative;
                display: flex;
                background-color: black;
                background-size: contain;
                background-position: center center;
                background-repeat: no-repeat;
            }

						.container object,
						.container embed {
							border: none;
    					position: absolute;
							width: 100%;
            	height: 100%;
						}
        
            .toolbar {
                color: white;
                padding-right: 10px;
                align-items: center;
                height: 60px;
                background-color: #303f9f;
                display: flex;
                justify-content: space-between;
                fill: #fff;
            }

            .toolbar div {
                display: flex;
            }

            .toolbar div div {
                margin: 0 10px;
            }
        </style>
        
        <div class="toolbar">
            <div>
                <div  @click="${() => this._close()}">${close}</div>
            </div>
            <div>
                <div @click="${() => this._download()}" ?hidden="${!this._inspId}" >${fileDownload}</div>
            </div>
        </div>
        <div class="container">
					<object data="${this._url}" type="application/pdf">
						
							<p>This browser does not support inline viewing PDFs. Please download the PDF to view it: 
                                <a href="#" @click="${(e) => this._download(e)}">Download PDF</a>.
                            </p>
						
					</object>
        </div>`;
	}
    
	connectedCallback() {
		super.connectedCallback();
		document.body.classList.add('freeze-scroll');
	}
    
	disconnectedCallback() {
		super.disconnectedCallback();
		document.body.classList.remove('freeze-scroll');
	}

	constructor(data, inspId, reportName) {
		super();
		this._url = URL.createObjectURL(data);
		
		this._inspId = inspId;
		this._reportName = reportName;
	}

	_close() {
		URL.revokeObjectURL(this._url);
		this.remove();
	}

	_download(e) {
		if (e) {
			e.preventDefault();
		}
		store.dispatch(downloadPdfReport(this._inspId, this._reportName));
	}
}

window.customElements.define("insp-report-viewer", InspReportViewer);
